import './ReportHeroPanel.style.less'

import {
  Button,
  Col,
  Dropdown,
  Input,
  MenuProps,
  Row,
  Spin,
  Switch,
  notification,
} from 'antd'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { capitalize, get, includes, indexOf, sortBy, startCase } from 'lodash'
import { inviteReviewerPermissionFN, isEmptyValue } from '@/utils/common'
import { useAuth } from '@/providers/auth.provider'
import moment from 'moment'

import {
  DeleteOutlined,
  FileExcelOutlined,
  FilePdfOutlined,
  HistoryOutlined,
  InfoCircleFilled,
  Loading3QuartersOutlined,
  MoreOutlined,
  RetweetOutlined,
  UnlockOutlined,
  WarningFilled,
} from '@ant-design/icons'
import ModalConfirm from '@/components/ModalConfirm/ModalConfirm'
import { queryClient } from '@/config/react-query'
import {
  deleteApprovedInspection,
  deleteInspection,
} from '@/screens/QSF/Inspection/Inspection.service'
import { useEffect, useState } from 'react'
import { useMutation, useQuery } from 'react-query'
import ModalReInspection from '@/screens/QSF/Inspection/ListInspection/components/ModalReInspection/ModalReInspection'
import {
  approveInspectionRef,
  getInspectionReportHeader,
  unlockApprovedInspectionRef,
} from '../../InSpectionReport.service'
import {
  canUserApproveReport,
  getDownloadCAPUrl,
  approveFeatureEnabled,
  unlockFeatureEnabled,
} from '../../InspectionReport.util'
import Fade from '@/components/Fade'
import SkeletonLoading from '@/components/SkeletonLoading/SkeletonLoading'
import DrawerUpdates from '../DrawerUpdates/DrawerUpdates'
import { InspectionStatus, InspectionTemplateType } from '@/constant/qsf'
import ReactDOMServer from 'react-dom/server'
import { IsAdminRole } from '@/utils/users'
import { eventBus } from '@/utils/eventBus'
import ChatButton from '@/components/ChatButton/ChatButton'
import { MITT_EVENT_BUS } from '@/constant/common'
import {
  useApproveSamplesHook,
  useRequestRevisionsHook,
} from '@/screens/QSF/Inspection/Inspection.hook'
import {
  INSPECTION_TYPE_SUBMIT_FOR_REVIEW,
  InspectionConstant,
} from '@/screens/QSF/Inspection/Inspection.constant'
import ChatIcon from '@/components/ChatIcon'

const { INSPECTION_REPORT_COMMENT } = MITT_EVENT_BUS
const { APPROVED, UNDER_REVIEW, NEEDS_REVISIONS, SUBMITTED } = InspectionStatus

interface Props {
  onClickExcel: () => void
  onClickPDF: () => void
  onClickPDFWithComment: () => void
  loadingPdf: boolean
  loadingExcel: boolean
  onToggleEdit: (value: boolean) => void
  editable: boolean
  refrechInspection
  inspection
  ReportPage: any
}

function ReportHeroPanel({
  onClickPDF,
  onClickPDFWithComment,
  loadingPdf,
  onToggleEdit,
  editable,
  refrechInspection,
  inspection,
  ReportPage,
}: Props) {
  const navigate = useNavigate()
  const { user } = useAuth()
  const userRole = user.subscription.role_access.role
  const isInvitedAsReviewer = inviteReviewerPermissionFN(user, inspection)

  const [modalDelete, setmodalDelete] = useState(false)
  const [modalRequestRevision, setModalRequestRevision] = useState(false)
  const [reInspectionModal, setReInspectionModal] = useState(false)
  const [modalApprove, setmodalApprove] = useState(false)
  const [modalApproveSample, setModalApproveSample] = useState(false)
  const [modalUnlock, setModalUnlock] = useState(false)
  const [revisionComment, setrevisionComment] = useState('')

  const renderModalContent = () => (
    <span>
      Once unlocked, this report will become editable again and its status will
      be reverted to <strong>Submitted.</strong>
    </span>
  )
  const renderApproveReport = () => {
    const isAllowApproveReport = approveFeatureEnabled(user, inspection)

    if (isAllowApproveReport) {
      return (
        <Button
          onClick={() => onShowApprove()}
          size="large"
          className="approve-button"
        >
          Approve Report
        </Button>
      )
    }
  }

  const [drawerUpdates, setdrawerUpdates] = useState(false)
  const [stateIsLoadingButton, setStateIsLoadingButton] = useState(false)

  const param: any = useParams()

  const inspectionRound = get(inspection, 'round')
  const commentRound = get(inspection, 'comment_round')
  const inspectionStatus = get(inspection, 'status')

  const SORTING_MENU = [
    're-inspection',
    'download-as-pdf',
    'inspections_export_supplier_cap',
    'download-pdf-with-comments',
    'view-comments',
    'unlock-report',
    'view-history',
    'delete',
  ]

  const onShowApprove = () => {
    setmodalApprove(true)
    onToggleEdit(false)
  }

  const location = useLocation()

  const onGoBack = () => {
    if (location.key !== 'default') {
      navigate(-1)
    } else {
      navigate('/qsf')
    }
  }

  const requestRevision = useRequestRevisionsHook()
  const approveSample = useApproveSamplesHook()

  const {
    data: data,
    isLoading: isLoadingHeader,
    refetch: refetchDataHeader,
  } = useQuery('GET_REPORT_DATA_HEADER', async () => {
    return await getInspectionReportHeader(param?.key)
  })

  const deleteMutation = useMutation(async () => {
    const isApproved = inspection?.status === InspectionStatus.APPROVED
    if (isApproved) {
      await deleteApprovedInspection(param?.key)
    } else {
      await deleteInspection(param?.key)
    }
    await queryClient.invalidateQueries([
      InspectionConstant.QUERY_KEY.INSPECTIONS_ADVANCE_SUMMARY,
    ])
  })

  const approveMutation = useMutation(async () => {
    await approveInspectionRef(
      param?.key,
      String(ReactDOMServer.renderToString(ReportPage({ isApproved: true })))
    )
    await queryClient.refetchQueries(['GET_REPORT_DATA'])
    await refetchDataHeader()
    await refrechInspection()
  })

  const unlockMutation = useMutation(async () => {
    await unlockApprovedInspectionRef(param?.key)
    await queryClient.refetchQueries(['GET_REPORT_DATA'])
    await refetchDataHeader()
    await refrechInspection()
  })

  const handleRenderNotification = ({ message, status }: any) => {
    if (status) {
      notification.success({
        message: message,
        duration: 4,
        placement: 'top',
      })
    } else {
      notification.error({
        message: message,
        duration: 4,
        placement: 'top',
      })
    }
  }

  useEffect(() => {
    if (approveMutation.isError) {
      const err: any = approveMutation.error
      notification.error({
        message: err.response?.data?.message,
        duration: 4,
        placement: 'top',
      })
    }
  }, [approveMutation.isError])

  useEffect(() => {
    const { isError, error, isSuccess }: any = requestRevision
    if (isError) {
      const message = error.response.data.message ?? ''
      handleRenderNotification({ message, status: false })
      setStateIsLoadingButton(false)
    }
    if (isSuccess) {
      setModalRequestRevision(false)
      refetchDataHeader()
      refrechInspection()
      handleRenderNotification({
        message: 'Revisions requested successfully.',
        status: true,
      })
      setStateIsLoadingButton(false)
    }
  }, [requestRevision.isError, requestRevision.isSuccess])

  useEffect(() => {
    const { isError, error, isSuccess } = approveSample
    if (isError) {
      const message = get(error, 'response.data.message', '')
      handleRenderNotification({ message, status: false })
      setStateIsLoadingButton(false)
    }

    if (isSuccess) {
      setModalApproveSample(false)
      handleRenderNotification({
        message: 'Inspection approved successfully.',
        status: true,
      })
      refetchDataHeader()
      refrechInspection()
    }
  }, [approveSample.isError, approveSample.isSuccess])

  useEffect(() => {
    if (unlockMutation.isError) {
      const err: any = unlockMutation.error
      notification.error({
        message: err.response?.data?.message,
        duration: 4,
        placement: 'top',
      })
    }
  }, [unlockMutation.isError])

  const onNavigate = (id: string) => {
    navigate('/loading', { replace: true })
    setTimeout(() => {
      navigate('/qsf/report/' + id, { replace: true })
    }, 100)
  }

  const onDownloadCAP = () => {
    window.open(getDownloadCAPUrl(inspection?.id), '_blank')
  }

  const items: MenuProps['items'] = [
    {
      key: 'download-as-pdf',
      label: 'Download as PDF',
      icon: <FilePdfOutlined />,
      className: 'dropdown-item',
      onClick: () => onClickPDF(),
    },
    {
      key: 'view-history',
      label: 'View History',
      icon: <HistoryOutlined />,
      className: 'dropdown-item',
      onClick: () => setdrawerUpdates(true),
    },
  ]

  if (
    includes(
      [InspectionTemplateType.FCCA],
      get(inspection, 'template.report_type')
    )
  ) {
    items.splice(1, 0, {
      key: 'inspections_export_supplier_cap',
      label: 'Download CAP',
      icon: <FileExcelOutlined />,
      className: 'dropdown-item',
      onClick: onDownloadCAP,
    })
  }

  if (includes([INSPECTION_TYPE_SUBMIT_FOR_REVIEW], inspection?.type)) {
    items.push({
      key: 'download-pdf-with-comments',
      label: 'Download PDF with Comments',
      icon: <FilePdfOutlined />,
      className: 'dropdown-item',
      onClick: () => onClickPDFWithComment(),
    })
  }

  const isAdmin = IsAdminRole(user)
  const isApproveEnable = canUserApproveReport(user, inspection)
  const isUnlockEnable = unlockFeatureEnabled(user, inspection)

  if (
    isAdmin &&
    inspection?.status !== InspectionStatus.APPROVED &&
    !inspection?.is_re_inspection &&
    isEmptyValue(data?.re_inspections)
  ) {
    items.unshift({
      key: 're-inspection',
      label: 'Create Re-inspection',
      icon: <RetweetOutlined />,
      className: 'dropdown-item',
      onClick: () => {
        setReInspectionModal(true)
      },
    })
  }

  items.push({
    key: 'unlock-report',
    label: 'Unlock Report',
    icon: <UnlockOutlined />,
    className: 'dropdown-item',
    disabled: !isUnlockEnable,
    onClick: () => setModalUnlock(true),
  })

  items.push({
    key: 'delete',
    label: 'Delete',
    icon: <DeleteOutlined />,
    className: 'dropdown-item',
    disabled: !isApproveEnable,
    onClick: () => setmodalDelete(true),
  })

  if (
    includes([APPROVED, SUBMITTED], inspection?.status) &&
    includes([INSPECTION_TYPE_SUBMIT_FOR_REVIEW], inspection?.type)
  ) {
    items.push({
      key: 'view-comments',
      label: 'View Comments',
      icon: (
        <span>
          <ChatIcon isWhite />
        </span>
      ),
      className: 'dropdown-item',
      onClick: () => {
        eventBus.emit(INSPECTION_REPORT_COMMENT)
      },
    })
  }

  const wrapMenuItems = sortBy(items, (o) => indexOf(SORTING_MENU, o.key))

  const onDelete = async () => {
    await deleteMutation.mutateAsync()
    setmodalDelete(false)
    onGoBack()
  }

  const onApprove = async () => {
    await approveMutation.mutateAsync()
    setmodalApprove(false)
  }

  const onRequestRevision = () => {
    setStateIsLoadingButton(true)
    requestRevision.mutate({
      inspectionId: inspection?.id,
      payload: { comment: revisionComment },
    })
  }

  const onApproveSample = async () => {
    setStateIsLoadingButton(true)
    await approveSample.mutate({
      inspectionId: inspection?.id,
    })
  }

  const onUnlock = async () => {
    await unlockMutation.mutateAsync()
    setModalUnlock(false)
  }

  const onNavigateReInspection = () => {
    ;[InspectionStatus.APPROVED, InspectionStatus.SUBMITTED].includes(
      data?.re_inspections[0].status
    )
      ? onNavigate(data?.re_inspections[0]?.id)
      : null
  }

  const onNavigatedMainInspection = () => {
    ;[InspectionStatus.APPROVED, InspectionStatus.SUBMITTED].includes(
      data?.inspection.status
    )
      ? onNavigate(data?.inspection?.id)
      : null
  }

  const bulletColorMainInspection = () => {
    return data?.inspection.status == 'IN_PROGRESS'
      ? '#ef9747'
      : [InspectionStatus.APPROVED, InspectionStatus.SUBMITTED].includes(
          data?.status
        )
      ? '#65BF73'
      : '#4A8DC0'
  }

  const bulletColorReInpsection = () => {
    return data?.re_inspections[0].status == 'IN_PROGRESS'
      ? '#ef9747'
      : [InspectionStatus.APPROVED, InspectionStatus.SUBMITTED].includes(
          data?.re_inspections[0].status
        )
      ? '#65BF73'
      : '#4A8DC0'
  }

  const colorCursorReInspection = () => {
    return {
      cursor: [InspectionStatus.APPROVED, InspectionStatus.SUBMITTED].includes(
        data?.re_inspections[0].status
      )
        ? 'pointer'
        : 'auto',
      color: [InspectionStatus.APPROVED, InspectionStatus.SUBMITTED].includes(
        data?.re_inspections[0].status
      )
        ? '#4A8DC0'
        : '',
    }
  }

  const colorCursorMainInspection = () => {
    return {
      cursor: [InspectionStatus.APPROVED, InspectionStatus.SUBMITTED].includes(
        data?.inspection.status
      )
        ? 'pointer'
        : '',
      color: [InspectionStatus.APPROVED, InspectionStatus.SUBMITTED].includes(
        data?.status
      )
        ? '#4A8DC0'
        : '',
    }
  }

  const renderComments = () => {
    let resultContent = null

    if (includes([UNDER_REVIEW, NEEDS_REVISIONS], inspection?.status)) {
      if (isInvitedAsReviewer) {
        resultContent = (
          <div style={{ marginRight: 10 }}>
            <ChatButton
              onClick={() => eventBus.emit(INSPECTION_REPORT_COMMENT)}
              chatCount={inspection?.comment_counter}
              redPoint={inspectionRound === commentRound}
            />
          </div>
        )
      }
    }

    return resultContent
  }

  const handleRenderContentApproveSample = () => {
    if (includes([NEEDS_REVISIONS], inspectionStatus)) {
      return (
        <div className="modal-approve-sample-content">
          <p>
            This inspection is
            <strong> under revisions. </strong>
            Once approved, it will
            <strong>
              {' '}
              no longer be available on the inspector’s mobile device,{' '}
            </strong>
            but you can still
            <strong> edit it on web.</strong>
          </p>
          <Row style={{ marginTop: 10 }}>
            <Col span={2}>
              {/* <InfoCircleFilled /> */}
              <WarningFilled className="warning" />
            </Col>
            <Col span={22}>
              <p>
                <strong>Are you sure you want to proceed?</strong>
              </p>
            </Col>
          </Row>
        </div>
      )
    }
    if (includes([UNDER_REVIEW], inspectionStatus)) {
      return (
        <div className="modal-approve-sample-content">
          <p>
            Once approved, this inspection will
            <strong>
              {' '}
              no longer be available on the inspector’s mobile device.
            </strong>
          </p>
          <Row style={{ marginTop: 10 }}>
            <Col span={2}>
              <InfoCircleFilled />
            </Col>
            <Col span={22}>
              You can still <strong>edit it on web </strong> to make any
              updates, or <strong>approve the report</strong> to lock it as
              final.
            </Col>
          </Row>
        </div>
      )
    }
  }

  const handleRenderStatus = () => {
    let showStatus: string = capitalize(startCase(data?.status))
    let colorStatus = 'success-color'

    if (includes([NEEDS_REVISIONS], data?.status)) {
      showStatus = 'Needs Revisions'
      colorStatus = 'secondary-red'
    }

    if (includes([UNDER_REVIEW], data?.status)) {
      showStatus = 'Under Review'
      colorStatus = 'primary-color'
    }

    return (
      <Row align={'middle'}>
        <span className={`bullet-point ${colorStatus}`} />
        <p className="status-report">{showStatus}</p>
      </Row>
    )
  }

  if (isLoadingHeader)
    return (
      <div className="report-skeleton-loading">
        <SkeletonLoading />
      </div>
    )

  return (
    <Fade>
      <div className="report-hero-container">
        <Row>
          <Col span={24}>
            <Row justify="start">
              <Col span={24}>
                <Row align={'middle'} justify={'space-between'}>
                  <Row>
                    <Row align={'middle'}>
                      <p className="report-number">
                        Inspection {data?.number}{' '}
                      </p>
                      {!isEmptyValue(data?.inspection) && (
                        <span className="tag-relate-number">RE</span>
                      )}
                    </Row>
                    {handleRenderStatus()}

                    {loadingPdf && (
                      <Row align={'middle'} style={{ marginLeft: 32 }}>
                        <Spin
                          indicator={
                            <Loading3QuartersOutlined
                              style={{ fontSize: 25 }}
                              spin
                            />
                          }
                        />
                      </Row>
                    )}
                  </Row>

                  <Row align={'middle'}>
                    {renderComments()}

                    {includes([SUBMITTED], inspection?.status) && (
                      <Row style={{ marginRight: 15 }}>
                        <p className="edit-label">Edit</p>
                        <Switch
                          checked={editable}
                          disabled={loadingPdf}
                          onChange={(value) => onToggleEdit(value)}
                        />
                      </Row>
                    )}
                    {includes([UNDER_REVIEW], inspection?.status) &&
                      isInvitedAsReviewer && (
                        <Button
                          onClick={() => setModalRequestRevision(true)}
                          size="large"
                          className="revision-button"
                        >
                          Request Revisions
                        </Button>
                      )}
                    {includes(
                      [UNDER_REVIEW, NEEDS_REVISIONS],
                      inspection?.status
                    ) &&
                      isInvitedAsReviewer && (
                        <Button
                          onClick={() => setModalApproveSample(true)}
                          size="large"
                          className="approve-button"
                        >
                          Approve Sample
                        </Button>
                      )}
                    {renderApproveReport()}

                    <Dropdown
                      className="dropdown-container"
                      trigger={['click']}
                      menu={{
                        items: wrapMenuItems?.filter(
                          (tmp: any) => !tmp.disabled
                        ),
                      }}
                    >
                      <Button
                        size="large"
                        className="action-report-button"
                        type="primary"
                        icon={<MoreOutlined />}
                      />
                    </Dropdown>
                  </Row>
                </Row>
                <Row style={{ margin: '5px 0' }} justify={'space-between'}>
                  <p className="date-text">
                    Last modification on:{' '}
                    <span className="strong">
                      {moment(data?.lastModifiedDate)
                        .local()
                        .format('DD MMM YYYY hh:mm A')}
                    </span>{' '}
                    by <span className="strong">{data?.lastModifiedBy}</span>
                  </p>
                </Row>
              </Col>
            </Row>
            <Row align="middle" justify={'space-between'}>
              {!isEmptyValue(data?.re_inspections) && (
                <Col span={12}>
                  <Row>
                    <p className="label-relate">Related inspection:</p>
                    <p
                      className="number-relate"
                      style={colorCursorReInspection()}
                      onClick={onNavigateReInspection}
                    >
                      {data?.re_inspections[0]?.number}
                    </p>
                    <p className="tag-relate">RE</p>
                    <Row align={'middle'}>
                      <div
                        className="bullet-relate"
                        style={{
                          backgroundColor: bulletColorReInpsection(),
                        }}
                      />
                      <p className="status-relate">
                        {' '}
                        {capitalize(
                          data?.re_inspections[0]?.status
                            ?.replace('-', ' ')
                            ?.replace('_', ' ')
                        )}
                      </p>
                    </Row>
                  </Row>
                </Col>
              )}
              {!isEmptyValue(data?.inspection) && (
                <Col span={12}>
                  <Row>
                    <p className="label-relate">Related inspection:</p>
                    <p
                      className="number-relate"
                      style={colorCursorMainInspection()}
                      onClick={onNavigatedMainInspection}
                    >
                      {data?.inspection?.number}
                    </p>
                    <Row align={'middle'}>
                      <div
                        className="bullet-relate"
                        style={{
                          backgroundColor: bulletColorMainInspection(),
                        }}
                      />
                      <p className="status-relate">
                        {' '}
                        {capitalize(
                          data?.inspection?.status
                            ?.replace('-', ' ')
                            ?.replace('_', ' ')
                        )}
                      </p>
                    </Row>
                  </Row>
                </Col>
              )}
            </Row>
          </Col>
        </Row>
        {modalDelete && (
          <ModalConfirm
            onOK={onDelete}
            loading={deleteMutation.isLoading}
            onCancel={null}
            confirmButtonText="Yes, Delete"
            cancelButtonText="No, Cancel"
            title="Delete Inspection"
            type="delete"
            content={
              <div>
                Are you sure you want to delete the inspection no.{' '}
                <strong>{data?.number}</strong>? You won’t be able to access it
                anymore.
              </div>
            }
            open={modalDelete}
            onClose={() => setmodalDelete(false)}
          />
        )}
        {modalApprove && (
          <ModalConfirm
            onOK={() => onApprove()}
            loading={approveMutation.isLoading}
            onCancel={() => setmodalApprove(false)}
            confirmButtonText="Yes, Confirm"
            cancelButtonText="No, Cancel"
            title="Confirm Approval"
            content={
              <div>
                You are about to finalize this report. Once approved, you won’t
                be able to edit it anymore.
                <br /> <br />
                <strong>This report will be locked from further edits. </strong>
                <br /> Are you sure you want to proceed?
              </div>
            }
            open={modalApprove}
            onClose={() => setmodalApprove(false)}
          />
        )}
        {modalRequestRevision && (
          <ModalConfirm
            onOK={onRequestRevision}
            noIcon
            loading={stateIsLoadingButton}
            onCancel={() => setModalRequestRevision(false)}
            confirmButtonText="Send for Revisions"
            cancelButtonText="Cancel"
            title="Request Revisions?"
            content={
              <span>
                This will <b>unlock the inspection for edition on mobile.</b>{' '}
                Your comments will be sent to the inspector.
                <Input.TextArea
                  className="revision-comment-text-area"
                  placeholder="Your overall comments (optional)"
                  value={revisionComment}
                  onChange={(e) => setrevisionComment(e.target.value)}
                />
              </span>
            }
            open={modalRequestRevision}
            onClose={() => setModalRequestRevision(false)}
          />
        )}
        {modalApproveSample && (
          <ModalConfirm
            onOK={onApproveSample}
            loading={stateIsLoadingButton}
            onCancel={() => setModalApproveSample(false)}
            noIcon
            onClose={() => setModalApproveSample(false)}
            confirmButtonText="Yes, Approve"
            cancelButtonText="Cancel"
            title="Approve Sample?"
            content={handleRenderContentApproveSample()}
            open={modalApproveSample}
          />
        )}

        {modalUnlock && (
          <ModalConfirm
            onOK={onUnlock}
            loading={unlockMutation.isLoading}
            onCancel={() => setModalUnlock(false)}
            confirmButtonText="Yes, Unlock"
            cancelButtonText="No, Cancel"
            title="Unlock Approved Report"
            content={renderModalContent()}
            open={modalUnlock}
            onClose={() => setModalUnlock(false)}
          />
        )}

        {reInspectionModal && (
          <ModalReInspection
            userRole={userRole}
            inspection={inspection}
            visible={reInspectionModal}
            onFinish={() => {
              refrechInspection()
              refetchDataHeader()
            }}
            onClose={() => {
              setReInspectionModal(false)
            }}
          />
        )}

        <DrawerUpdates
          open={drawerUpdates}
          inspectionData={inspection}
          onClose={() => setdrawerUpdates(false)}
        />
      </div>
    </Fade>
  )
}

export default ReportHeroPanel
